interface ClickableVideoItemProps {
  text: string;
  onClick?: () => void;
}

export const ClickableVideoItem = ({
  text,
  onClick,
}: ClickableVideoItemProps) => {
  return (
    <div
      onClick={onClick}
      className="flex justify-center items-center gap-2 px-3 py-[13.5px] rounded-md bg-blue-2948FF text-white leading-3 hover:cursor-pointer"
    >
      <div className="flex justify-center gap-2">
        <i className="-mt-1.5 h-0 ki-outline ki-abstract-41 text-md" />
        <div className="text-[12.5px] font-semibold [word-spacing:0.055em] uppercase truncate max-w-[200px]">
          {text}
        </div>
      </div>
    </div>
  );
};
